module.exports = __webpack_public_path__ + "img/deletepopupicon.2ec00bac.svg";